import * as types from '../actions/actionTypes';
import initialState from './initialState';
import _ from 'underscore';

function tourReducer(state = initialState.tour, action) {
    switch(action.type) {
        case types.TOUR_ENABLED_CHANGED:
            const newState = _(state).clone();
            newState[action.tour] = action.enabled;
            return newState;

        default:
            return state;
    }
}

export default (state, action) => {
    return tourReducer(state, action);
};


// WEBPACK FOOTER //
// ./src/js/reducers/tourReducer.js